/** Вход монтажника (п. 6.1 ТЗ). Регистрации нет — учётки заводит администратор. */

import { useState } from 'react'
import type { FormEvent } from 'react'

import { ApiError, api } from '../api/client'
import type { User } from '../api/types'
import { Alert, Button, Field } from '../components/ui'

export function LoginScreen({ onLoggedIn }: { onLoggedIn: (user: User) => void }) {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<ApiError | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    if (!login.trim() || !password) return
    setBusy(true)
    setError(null)
    try {
      const response = await api.login(login.trim(), password)
      setPassword('')
      onLoggedIn(response.user)
    } catch (err) {
      setError(err instanceof ApiError ? err : new ApiError(0, 'Неизвестная ошибка'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <form className="card" onSubmit={submit}>
      <h2>Вход монтажника</h2>
      <p className="subtitle">Логин и пароль выдаёт администратор.</p>

      {error && (
        <Alert
          kind="error"
          title={error.retryable ? 'Сервер недоступен' : 'Вход не выполнен'}
          onDismiss={() => setError(null)}
        >
          {error.message}
        </Alert>
      )}

      <Field
        name="login"
        label="Логин"
        value={login}
        onChange={setLogin}
        required
        autoComplete="username"
      />
      <Field
        name="password"
        label="Пароль"
        type="password"
        value={password}
        onChange={setPassword}
        required
        autoComplete="current-password"
      />

      <Button type="submit" block busy={busy} disabled={!login.trim() || !password}>
        Войти
      </Button>
    </form>
  )
}
